import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";

import { SiteForm } from "../components";
import { useSite, useUpdateSite } from "../hooks";

type IUpdateSite = {
  id: string;
};

export const UpdateSite: React.FC = () => {
  const { id } = useParams<IUpdateSite>();
  const navigate = useNavigate();
  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);
  const { data, refetch } = useSite(+id!);

  const { form, submit, loading } = useUpdateSite({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("Le client a été modifié avec succès");
    },
    onError(message) {
      toast.error(message);
    },
  });

  useEffect(() => {
    if (data) {
      form.setValue("name", data.site.result?.name);
      form.setValue("url", data.site.result?.url);
      form.setValue("categoryId", data.site.result?.categoryId);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }
  return (
    <>
      <Header
        title={"Produit"}
        subtitle="Modifier les informations du produit"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/site/${id}`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <SiteForm loading={loading} form={form} submit={submit} />
      </div>
    </>
  );
};
